@if (profile()) {
  <div
    class="d-flex flex-lg-row gap-3 justify-content-evenly"
  >
    <div
      class="d-flex flex-lg-row flex-column gap-3 justify-content-evenly"
    >

      @if(profile()?.role === 'physician') {
        <div class="card" style="width: 18rem;">
          <img [src]="nationalSrc" class="card-img-top card-bg" alt="National Citizen">
          <div class="card-body d-flex flex-column">
            <h5 class="card-title">{{ translations.national }}</h5>
            <p class="card-text flex-grow-1">{{ translations.national_text }}</p>
            <ncp-button (click)="goToCY()">
              {{ translations.enter }}
            </ncp-button>
          </div>
        </div>
      }

      <div class="card" style="width: 18rem;">
        <img [src]="europeanSrc" class="card-img-top card-bg" alt="European Citizen">
        <div class="card-body d-flex flex-column">
          <h5 class="card-title">{{ translations.european }}</h5>
          <p class="card-text flex-grow-1">{{ translations.european_text }}</p>
          <ncp-button (click)="goToEU()">
            {{ translations.enter }}
          </ncp-button>
        </div>
      </div>

<!--      <div class="card" style="width: 18rem;">-->
<!--        <img [src]="profileSrc" class="card-img-top bg-primary" alt="Profile">-->
<!--        <div class="card-body">-->
<!--          <h5 class="card-title">{{ translations.profile }}</h5>-->
<!--          <p class="card-text">{{ translations.profile_text }}</p>-->
<!--          <ncp-button (click)="goToProfile()">-->
<!--            {{ translations.enter }}-->
<!--          </ncp-button>-->
<!--        </div>-->
<!--      </div>-->

    </div>
<!--    <div class="">-->
<!--      <ncp-button (click)="goToCY()">-->
<!--        <div-->
<!--          class="home-tile btn-block button-container home-tile_current button-container_current"-->
<!--        >-->
<!--          <span class="label-text">{{ translations.national }}</span>-->
<!--          <div class="image-container">-->
<!--            <img-->
<!--              class="btn-img"-->
<!--              [src]="nationalSrc"-->
<!--              alt="National Citizen"-->
<!--            />-->
<!--          </div>-->
<!--        </div>-->
<!--      </ncp-button>-->
<!--    </div>-->

<!--    <div class="">-->
<!--      <ncp-button (click)="goToEU()">-->
<!--        <div-->
<!--          class="home-tile btn-block button-container home-tile_current button-container_current"-->
<!--        >-->
<!--          <span class="label-text">{{ translations.european }}</span>-->
<!--          <div class="image-container">-->
<!--            <img-->
<!--              class="btn-img"-->
<!--              [src]="europeanSrc"-->
<!--            />-->
<!--          </div>-->
<!--        </div>-->
<!--      </ncp-button>-->
<!--    </div>-->

<!--    <div class="">-->
<!--      <ncp-button (click)="goToProfile()">-->
<!--        <div-->
<!--          class="home-tile btn-block button-container home-tile_current button-container_current"-->
<!--        >-->
<!--          <span class="label-text">{{ translations.profile }}</span>-->
<!--          <div class="image-container">-->
<!--            <img-->
<!--              class="btn-img"-->
<!--              [src]="profileSrc"-->
<!--            />-->
<!--          </div>-->
<!--        </div>-->
<!--      </ncp-button>-->
<!--    </div>-->

  </div>
} @else if (!isLoggingIn) {
  <ng-container
    [ngComponentOutlet]="LoginComponent"
    #outlet="ngComponentOutlet"
  />
} @else {
  <div
    class="loader d-flex flex-row justify-content-center"
  >
    <p-progress-spinner ariaLabel="loading" />
  </div>
}
